import React, { useContext } from 'react'
import classNames from 'classnames'
import {
  TicketOnList,
  TicketListManagerContext,
} from '~/service/TicketListManager'
import { Link } from 'react-router-dom'
import { stripHtml } from 'string-strip-html'
import Star, { stars } from '~/components/common/Star'
import DateTooltip from '~/components/common/DateTooltip'
import { FormattedMessage } from 'react-intl'

type Props = {
  ticket: TicketOnList
  width: number
}

const Item: React.FC<Props> = ({ ticket, width }) => {
  const reportType = window.c.ticketReportTypes[ticket.reportedBy]
  const { setItems } = useContext(TicketListManagerContext)

  const star =
    ticket.stars && ticket.stars[0].colorId != 0
      ? { color: stars[ticket.stars[0].colorId] }
      : null

  const check = () => {
    setItems(items =>
      items.map(item =>
        item.id == ticket.id ? { ...item, checked: !ticket.checked } : item
      )
    )
  }

  const Tags = () => {
    return (
      <>
        {ticket.urgent && (
          <span className="tag is-danger is-rounded ticket-list-item-tag">
            <FormattedMessage id="ticket / badge / urgent" />
          </span>
        )}
        <em
          className="tag is-light is-rounded ticket-list-item-tag ticket-list-item-tag-type"
          title={reportType.name}
        >
          <span className={classNames('fa', reportType.class)}></span>
        </em>
        {width > 900 && ticket.tags.length > 0 && (
          <span className="ticket-list-item-tags">
            {ticket.tags.map(tag => tag.name + ' ')}
          </span>
        )}
      </>
    )
  }

  return (
    <>
      <div
        className={classNames('list-item ticket-list-item', {
          'is-active': window.location.pathname == '/tickets/' + ticket.number,
        })}
      >
        <div className="ticket-list-item-col ticket-list-item-col">
          <div className="ticket-list-item-checkbox">
            <label className="checkbox">
              <input
                type="checkbox"
                id={'lim-table-checkbox-' + ticket.id}
                defaultChecked={ticket.checked}
                checked={ticket.checked}
                onChange={() => check()}
                disabled={ticket.ticketCategoryStatus ? true : false}
              />
            </label>
          </div>
        </div>
        {width > 900 && (
          <div className="ticket-list-item-col ticket-list-item-col-star">
            <Star type="ticket" star={star} id={ticket.id} />
          </div>
        )}
        <Link to={'/tickets/' + ticket.number} className="ticket-list-item-col">
          <div className="ticket-list-item-avatar">
            <img src={ticket.avatar} />
          </div>
        </Link>
        <Link
          to={'/tickets/' + ticket.number}
          className="ticket-list-item-col ticket-list-item-col-main"
        >
          <div className="ticket-list-item-client">
            {ticket.client ? (
              <>{ticket.client.name}</>
            ) : (
              <>{ticket.addedBy.name}</>
            )}
          </div>
          <div className="ticket-list-item-col-name">
            <div
              className={classNames('ticket-list-item-title', {
                'ticket-list-item-title-unreaded': ticket.unreaded,
                'ticket-list-item-title--small': width < 600,
              })}
            >
              {stripHtml(ticket.title).result}{' '}
            </div>
            <div
              className={classNames('ticket-list-item-content', {
                'ticket-list-item-content-unreaded': ticket.unreaded,
                'ticket-list-item-content--small': width < 600,
              })}
            >
              {stripHtml(ticket.firstAnswer).result}
            </div>

            {width > 900 && (
              <>
                {width > 900 && ticket.mailAccount && (
                  <div className="ticket-list-item-mail">
                    <span className="fa-solid fa-share"></span>
                    {'  ' + ticket.mailAccount}
                  </div>
                )}
                <div className="ticket-list-item-number">
                  <span>#{ticket.number}</span>
                  <Tags />
                </div>
                {ticket.ticketCategory && (
                  <div className="ticket-list-item-category">
                    <span
                      className={
                        ticket.ticketCategory.icon
                          ? ticket.ticketCategory.icon
                          : 'far fa-angle-double-right'
                      }
                    ></span>
                    {ticket.ticketCategory.name}
                    {ticket.ticketSubcategory &&
                      ' - ' + ticket.ticketSubcategory.name}
                  </div>
                )}
              </>
            )}
          </div>
        </Link>
        <Link to={'/tickets/' + ticket.number} className="ticket-list-item-col">
          {width > 900 && (
            <div className="ticket-list-item-date">
              <DateTooltip date={ticket.added} />
            </div>
          )}
          <div className="ticket-list-item-date">
            <DateTooltip date={ticket.dateLastAnswer} />
          </div>
          <div className="ticket-list-item-info">
            {ticket.assignedUsers.length > 0 ? (
              (() => {
                const users = ticket.assignedUsers
                  .slice(0, 2)
                  .map(assignedUser =>
                    window.c.users.find(user => user.id == assignedUser.id)
                  )

                const title = users.map(u => u?.name).join(', ')

                return (
                  <div className="ticket-list-item-col ticket-list-item-col-assigned">
                    <div
                      className="ticket-list-item-col-assigned-images"
                      data-tip={title}
                      data-delay-show="200"
                    >
                      {users.map(u => (
                        <img src={u?.avatar} key={u?.id} />
                      ))}
                    </div>
                  </div>
                )
              })()
            ) : (
              <div className="ticket-list-item-col ticket-list-item-col-assigned">
                {width > 900 && <span className="fa-solid fa-hyphen"></span>}
              </div>
            )}
            {width <= 900 && (
              <>
                <Tags />
                <Star type="ticket" star={star} id={ticket.id} />
              </>
            )}
          </div>
        </Link>
      </div>
    </>
  )
}

export default Item
